<template>
  <div ref="carouselContainer">
    <img
      v-if="!mediaArray?.length"
      alt="default image"
      class="carousel-image"
      :src="getPlaceHolderImg"
      :src-placeholder="getPlaceHolderImg"
    />
    <Carousel
      v-else
      :key="productId"
      :pauseAutoplayOnHover="true"
      :wrapAround="true"
      :pagination="true"
      :transition="0"
      :touchDrag="true"
      :mouseDrag="true"
      :autoplay="getAutoScrollEnabled ? autoplayDuration : 0"
      @click="playPauseCarousel"
    >
      <Slide
        :class="clientPlatform == 'Web' ? 'dt-banner-wrap' : 'banner-wrap'"
        v-for="item in mediaArray"
        :key="item?.mediaId"
      >
        <!-- Render images -->
        <template v-if="item.mediaType === 'IMAGE'">
          <img
            :src="item.mediaUrl"
            :src-placeholder="getPlaceHolderImg"
            :alt="item.altText"
            class="carousel-image"
            @error="handleImageError"
          />
        </template>

        <!-- Render videos -->
        <template v-if="item.mediaType === 'VIDEO'">
          <video
            :src="item.mediaUrl"
            :src-placeholder="getPlaceHolderImg"
            autoplay
            loop
            muted
            playsinline
            class="carousel-video"
            ref="carouselVideo"
            @error="handleImageError"
          ></video>
        </template>
      </Slide>
      <template #addons v-if="mediaArray?.length > 1">
        <Pagination />
      </template>
    </Carousel>
  </div>
</template>

<script>
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import { Carousel, Slide, Pagination } from "vue3-carousel";
export default {
  name: "ProductCardCarousel",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  props: {
    isAutoScrollEnabled: { required: false, default: true },
    imgArray: { required: false, default: [] },
    productId: { required: false, default: 1 },
  },
  data() {
    return {
      autoplay: 2000,
      isAutoPlay: true,
      clientPlatform,
      observer1: null,
      observer2: null,
      staticImgBaseUrl,
    };
  },
  mounted() {
    if ("IntersectionObserver" in window && this.getAutoScrollEnabled) {
      this.observer1 = new IntersectionObserver(
        (entries) => {
          const videoElements = this.$refs.carouselVideo;
          if (entries.some((entry) => entry.isIntersecting)) {
            this.autoplay = 2000;
            this.isAutoPlay = true;

            if (Array.isArray(videoElements)) {
              videoElements.forEach((video) => {
                if (video && typeof video.play === "function") {
                  video.play();
                }
              });
            }
          } else {
            this.autoplay = 0;
            if (Array.isArray(videoElements)) {
              videoElements.forEach((video) => {
                if (video && typeof video.pause === "function") {
                  video.pause();
                }
              });
            }
          }
        },
        {
          threshold: 0.1,
          rootMargin: "0px",
        }
      );
      this.observer1.observe(this.$refs.carouselContainer);
    }
  },
  unmounted() {
    if ("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    playPauseCarousel() {
      this.isAutoPlay = !this.isAutoPlay;
      this.autoplay = 2000;
    },
    handleImageError(event) {
      event.target.src =
        staticImgBaseUrl + "/images/global/PlaceholderImage.png";
      event.target.onerror = null;
    },
  },
  computed: {
    getAutoScrollEnabled() {
      return this.isAutoScrollEnabled && this.isAutoPlay;
    },
    autoplayDuration() {
      return this.autoplay;
    },
    imgBaseUrl() {
      return this.$store.state.ProductItems.imgBaseUrl;
    },
    getPlaceHolderImg() {
      return this.staticImgBaseUrl + "/images/global/PlaceholderImage.png";
    },
    mediaArray() {
      const validKeys = ["HomeProductV1", "HomeVideoV1"];
      const result = [];

      this.imgArray?.length &&
        this.imgArray.forEach((item) => {
          const mediaUrls = item.mediaUrls;
          const mediaType = item.mediaType;

          validKeys.forEach((key) => {
            if (mediaUrls[key]) {
              result.push({
                mediaType: mediaType,
                mediaUrl: this.imgBaseUrl + mediaUrls[key],
              });
            }
          });
        });

      return result;
    },
  },
};
</script>
